import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { Col, Row } from "react-bootstrap";

import { FormattedMessage, useIntl } from "react-intl";
import { editSection, getSection } from "store/actions";
import Loader from "components/shared/Loader";
import { useState } from "react";
import SaveChangesButton from "components/shared/SaveChangesButton";
import { toastErrorMessage } from "helpers/toaster/toastErrorMessage";
import { Input, Textarea } from "components/shared/FormComponents";
import TermsArray from "./TermsArray";

const Section = () => {
  const { formatMessage, locale } = useIntl();
  const dispatch = useDispatch();
  const { loading, error, section } = useSelector((state) => state.section);
  const [terms, setTerms] = useState([]);
  const [sectionActivition, setSectionActivition] = useState(true);
  const sectionActivitionHandler = () =>
    setSectionActivition(!sectionActivition);

  const {
    register,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm();
  // get single page by slug
  useEffect(() => {
    dispatch(
      getSection({
        page: "home",
        slug: "terms",
      })
    );
  }, [dispatch]);

  useEffect(() => {
    if (section?.terms) {
      // const updatedSections = [];

      // Object.entries(section?.features).forEach(([key, section]) =>  {

      //   section.id = v4();
      //   section.image = process.env.REACT_APP_URL + section?.image.slice(1);
      //   updatedSections.push(section)
      // });
      reset({
        heading: section?.heading,
        subHeading: section?.subHeading,
        terms: section?.terms,
      });
      setSectionActivition(section?.sectionActivition);

      setTerms(section?.terms);
    }
  }, [reset, section]);

  // error
  useEffect(() => {
    if (error) {
      toastErrorMessage(formatMessage({ id: "sendingErrorMessage" }), locale);
    }
  }, [error, formatMessage, locale]);

  const onSubmit = (data) => {
    // data.features = features.map(feature => {
    //   return { ...feature, image: `/uploads/${feature.image?.split("/").at(-1)}` }
    // })

    data.terms = terms;
    data.sectionActivition = sectionActivition;
    dispatch(
      editSection({ slug: "terms", page: "home", data: { section: data } })
    );
  };

  if (loading) return <Loader />;

  return (
    <>
      <div className="acc-form">
        <div className="card">
          <div className="card-head">
            <h4>
              <FormattedMessage id={"terms-conditions"} />
            </h4>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit(onSubmit)}>
              {/* heading  */}
              <Row>
                <Col lg={6} xs={12}>
                  <Input
                    langId="title"
                    name="heading.ar"
                    register={register}
                    errors={errors}
                  />
                </Col>
                <Col lg={6} xs={12}>
                  <Input
                    langId="title"
                    name="heading.en"
                    register={register}
                    errors={errors}
                    dir="ltr"
                  />
                </Col>
                <Col lg={6} xs={12}>
                  <Textarea
                    langId="subHeading"
                    name="subHeading.ar"
                    register={register}
                    errors={errors}
                  />
                </Col>
                <Col lg={6} xs={12}>
                  <Textarea
                    langId="subHeading"
                    name="subHeading.en"
                    register={register}
                    errors={errors}
                    dir="ltr"
                  />
                </Col>
              </Row>
              <Col md={4} xs={12}>
                <div className="only-radio toggle-switch mb-5">
                  <label className="switch-label" htmlFor="sectionActivition">
                    <FormattedMessage id="sectionActivition" />
                  </label>
                  <label className="switch" htmlFor="sectionActivition">
                    <input
                      id="sectionActivition"
                      type="checkbox"
                      checked={sectionActivition}
                      onChange={sectionActivitionHandler}
                    />
                    <span className="slider"></span>
                  </label>
                </div>
              </Col>
              <Col xl={12}>
                <TermsArray terms={terms} setTerms={setTerms} />

                <SaveChangesButton />
              </Col>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Section;
